// Shared helpers for the estimation / rate-library pages.

export function num(v: any): number {
  const n = typeof v === 'number' ? v : parseFloat(v);
  return Number.isFinite(n) ? n : 0;
}

// Indian digit grouping (12,34,567).
export function fmtIN(n: number): string {
  const neg = n < 0;
  const v = Math.abs(Math.round(n));
  let s = String(v);
  if (s.length > 3) {
    const last = s.slice(-3);
    const rest = s.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ',');
    s = rest + ',' + last;
  }
  return (neg ? '-' : '') + s;
}
